import sum from 'lodash-es/sum';

import { PickedRange } from '@shared/filters/entities/fetch-filters.response';

export function getPickedRangeLength(ranges: PickedRange): number {
  const numberOfRanges = {};
  Object.keys(ranges).forEach(range => {
    if (Array.isArray(ranges[range])) {
      numberOfRanges[range] = 1;
    } else {
      numberOfRanges[range] = 0;
      Object.keys(ranges[range]).forEach(filter => {
        if (ranges[range][filter].length) {
          numberOfRanges[range] = ++numberOfRanges[range];
        }
      });
    }
  });
  return sum(Object.values(numberOfRanges));
}
